export default {
      id: "icon-right-usage",
      viewBox: "0 0 19 18",
      url: "/" + "assets/sprite.svg#icon-right",
      toString: function () {
        return this.url;
      }
    }